import { render, staticRenderFns } from "./orderpayededit.vue?vue&type=template&id=a8825ebc&scoped=true&"
import script from "./orderpayededit.vue?vue&type=script&lang=js&"
export * from "./orderpayededit.vue?vue&type=script&lang=js&"
import style0 from "./orderpayededit.vue?vue&type=style&index=0&id=a8825ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8825ebc",
  null
  
)

export default component.exports